<template>
  <centered-layout :show-leaderboard-ad="true">
    <client-only>
      <poll-component v-if="engagement && engagement.id" :poll-data="engagement" />
    </client-only>
  </centered-layout>
</template>

<script>
import PollComponent from '@/components/EngagementToolkit/PollComponent.vue';
import { GET_ENGAGEMENT } from '@/graphql/queries/engagement-toolkit-queries';

export default {
  name: 'LegacySinglePollWrapper',
  components: {
    PollComponent,
  },
  props: {
    legacyPollId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      engagement: {},
      id: parseInt(this.legacyPollId, 10),
    };
  },
  computed: {
    invalidPollId() {
      return !this.id;
    },
  },
  mounted() {
    if (this.invalidPollId) {
      this.set404();
    } else {
      this.getEngagement();
    }
  },
  methods: {
    set404() {
      this.$logger.error(`invalid legacy poll ID ${this.legacyPollId}`);
      this.$store.dispatch('setIs404', true);
    },
    getEngagement() {
      this.$apollo.query({
        query: GET_ENGAGEMENT,
        variables: {
          legacyId: this.legacyPollId,
          type: 'poll',
        },
      })
        .then(({ data }) => {
          if (data && data.engagement) {
            this.engagement = data.engagement;
          } else if (data.engagement === null) {
            this.set404();
          }
        });
    },
  },
};
</script>
